module.exports = __webpack_public_path__ + "prod/20260124143402/img/logo.1444e71b.png";